import {Component, OnInit, Inject} from '@angular/core';
import {Router} from '@angular/router';
import {Page} from '../shared/page';
import {Auth} from '../shared/auth';
import {AuthService} from '../guard/auth.service';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material';
import {OkDialogComponent} from '../dialog/ok-dialog.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  page: Page = {
    title: 'Welcome to Data Steward UI',
    subtitle: ''
  };
  auth: Auth = new Auth();
  errorMessage: String = '';

  constructor(private router: Router, private authService: AuthService, private dialog: MatDialog) { }

  ngOnInit() {}

  login() {
    this.errorMessage = '';
    this.authService.login(this.auth).subscribe(
      (isLogged) => {
        if (isLogged) {
          sessionStorage.setItem('auth-credential', this.auth.encode());
          this.router.navigate(['home']);
        } else {
          this.auth.password = '';
          this.errorMessage = 'Invalid username/password';
        }
      },
      (err) => {
        this.auth.password = '';
        this.warningDialog('The system is temporarily out. IT has been notified to investigate.');
      }
    );
  }

  private warningDialog(message: string) {
    this.dialog.open(OkDialogComponent, {
      width: '500px',
      data: {'message': message}
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts